export default {"src":"/_next/static/media/long_line.5a946fa5.svg","height":9,"width":346,"blurWidth":0,"blurHeight":0};